/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Marketing_DescriptionInputs */

const en_cookie_marketing_description = /** @type {(inputs: Cookie_Marketing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These cookies are used to deliver relevant advertisements and track their effectiveness.`)
};

const lv_cookie_marketing_description = /** @type {(inputs: Cookie_Marketing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šīs sīkdatnes izmanto, lai rādītu Jums atbilstošas reklāmas un novērtētu to efektivitāti.`)
};

/**
* | output |
* | --- |
* | "These cookies are used to deliver relevant advertisements and track their effectiveness." |
*
* @param {Cookie_Marketing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cookie_marketing_description = /** @type {((inputs?: Cookie_Marketing_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Marketing_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cookie_marketing_description(inputs)
	return en_cookie_marketing_description(inputs)
});